import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ComboBoxOption } from 'src/app/models/combo-box-option';
import { ProductDistribution } from 'src/app/models/register/product/product-distribution';

@Component({
  selector: 'distribution-group',
  templateUrl: './distribution-group.component.html',
  styleUrls: ['./distribution-group.component.scss'],
})
export class DistributionGroupComponent implements OnInit {
  @Input()
  deliveryWayByGroup: ProductDistribution[] = [];

  @Input()
  isDownload?: boolean;

  @Input()
  prefixClassifications: ComboBoxOption[] = [];

  @Input()
  quantity: string = '0';

  @Input()
  isConfirmed: boolean = false;

  @Output()
  changed = new EventEmitter<any>();

  @Output()
  changeTotal = new EventEmitter<any>();

  @Input()
  totalValue: number = 0;

  currentTotal: number = 0;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.currentTotal = this.totalValue;

    console.log('classifications', this.prefixClassifications);
  }

  onChangeData(): void {
    this.changed.emit(this.deliveryWayByGroup);
  }

  onChangeTotal(): void {
    console.log('changed this total');
    this.changeTotal.emit({ type: 'C', total: this.currentTotal });
  }

  onToggle(rowIndex: any, event: any) {

    this.deliveryWayByGroup[rowIndex].checked = event.checked;

    this.cdr.detectChanges();

    this.onChangeData();
  }
}
